<template>
  <div
    class="ag-stepper-horizontal"
    :class="{
      'has-no-action':
        fullPath !== '/administration/policy-review/drafted' &&
        fullPath !== '/administration/policy-review/applied',
    }"
  >
    <div 
      class="ag-step active" 
      :class="{
        'has-active-no-btn': fullPath === '/administration/policy-review',
      }"
      @click="goTo('/administration/policy-review')">
      <small v-if="fullPath === '/administration/policy-review' && !$route.query.searchResults">Relax or retain these blocking policies?</small>
      <div class="ag-step-circle"><span>1</span></div>
      <div
        class="ag-step-title"
        :class="{
          'active-title':
            fullPath === '/administration/policy-review' &&
            !$route.query.searchResults,
        }"
      >
        Needs Review {{ data ? `(${data.uniqueBlocks})` : "" }}
      </div>
      <div class="ag-step-bar-left"></div>
      <div class="ag-step-bar-right"></div>
    </div>
    <div
      class="ag-step active"
      :class="{
        'has-action': fullPath === '/administration/policy-review/drafted',
      }"
    >
      <small v-if="fullPath === '/administration/policy-review/drafted'">Ready to apply these changes?</small>
      <a
        href="javascript:void(0);"
        class="ag-action-btn"
        @click="applyDecision"
        v-if="fullPath === '/administration/policy-review/drafted'"
      >
        {{$t("applyDecisions")}}
      </a>
      <div class="ag-step-circle"><span>2</span></div>
      <div
        class="ag-step-title"
        @click="goTo('/administration/policy-review/drafted')"
        :class="{
          'active-title':
            fullPath === '/administration/policy-review/drafted' &&
            !$route.query.searchResults,
        }"
      >
        {{$t("drafted")}} {{ data ? `(${data.drafts})` : "" }}
      </div>
      <div class="ag-step-bar-left"></div>
      <div class="ag-step-bar-right"></div>
    </div>
    <div
      class="ag-step active"
      :class="{
        'has-action': fullPath === '/administration/policy-review/applied',
      }"
    >
      <small v-if="fullPath === '/administration/policy-review/applied'">Ready for these changes to be published to endpoints?</small>
      <a
        href="javascript:void(0);"
        class="ag-action-btn"
        @click="goTo('/administration/group-dashboard')"
        v-if="fullPath === '/administration/policy-review/applied'"
      >
        {{$t("startPublishing")}}
      </a>
      <div class="ag-step-circle"><span>3</span></div>
      <div
        class="ag-step-title"
        :class="{
          'active-title':
            fullPath === '/administration/policy-review/applied' &&
            !$route.query.searchResults,
        }"
        @click="goTo('/administration/policy-review/applied')"
      >
        {{$t("applied")}} {{ data ? `(${data.applied})` : "" }}
      </div>
      <div class="ag-step-bar-left"></div>
      <div class="ag-step-bar-right"></div>
    </div>
    <div
      class="ag-step active"
      @click="goTo('/administration/policy-review/published')"
      :class="{
        'has-active-no-btn': fullPath === '/administration/policy-review/published',
      }"
    >
      <small v-if="fullPath === '/administration/policy-review/published'">Your published decisions are here.</small>
      <div class="ag-step-circle"><span>4</span></div>
      <div
        class="ag-step-title"
        :class="{
          'active-title':
            fullPath === '/administration/policy-review/published',
        }"
      >
        {{$t("published")}} {{ data ? `(${data.published})` : "" }}
      </div>
      <div class="ag-step-bar-left"></div>
    </div>
    <div
      class="ag-step active"
      @click="goTo('/administration/policy-review/keep-enforcing')"
    >
      <div class="ag-step-circle" style="opacity: 0"><span>1</span></div>
      <div
        class="ag-step-title"
        :class="{
          'active-title':
            fullPath === '/administration/policy-review/keep-enforcing',
        }"
      >
        {{$t("keepEnforcing")}} {{ data ? `(${data.keepEnforcing})` : "" }}
      </div>
    </div>
    <div class="ag-step active">
      <div class="ag-step-circle" style="opacity: 0"><span>1</span></div>
      <div
        class="ag-step-title"
        :class="{
          'active-title': $route.query.searchResults,
        }"
      >
        <router-link
          class="ag-step-title"
          to="?searchResults=true"
          exact
          @click="searchResultFunc"
          activeClass="none"
          exactActiveClass="none"
        >
          {{ t("searchResults") }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/index";
import { useI18n } from "vue-i18n";
import { useCommonStore } from "@/stores/common";
import { mapStores } from "pinia";
import moment from "moment";
export default {
  name: "ag-policy-navigation",
  data() {
    return {
      data: null,
      dateFilter: null,
    };
  },
  setup() {
    const { t, locale } = useI18n();
    return { t, locale };
  },
  computed: {
    fullPath() {
      return this.$route.fullPath;
    },
    ...mapStores(useCommonStore),
  },
  async mounted() {
    this.getCounts();
  },
  watch: {
    /* commonStore: {
      handler(val) {
        console.log(val);
        this.getCounts();
      },
      deep: true,
    }, */
  },
  methods: {
    async getCounts() {
      this.data = null;
      let payload = {};
      if (this.commonStore.hourDifference) {
        let startDate = new Date();
        let selectedDate = this.commonStore.dateFilter;
        startDate = moment(selectedDate.value)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS");

        let endDate = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS");

        payload = {
          startDate: startDate,
          endDate: endDate,
        };
      } else if (
        this.commonStore.dateFilter &&
        this.commonStore.dateFilter.endDate
      ) {
        let startDate = moment(this.commonStore.dateFilter.value)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS");
        let endDate = moment(this.commonStore.dateFilter.endDate)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS");
        payload = {
          startDate: startDate,
          endDate: endDate,
        };
      } else {
        let pStartDate = moment()
          .startOf("day")
          .subtract(7, "days")
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss.SSS");
        let pEndDate = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
        payload = {
          startDate: pStartDate,
          endDate: pEndDate,
        };
      }
      if (this.commonStore.policyFilter.type === "default") {
        payload = {
          StartPolicyFileVersion:
            this.commonStore.policyFilter.data.startVersion.value,
          EndPolicyFileVersion:
            this.commonStore.policyFilter.data.endVersion.value,
        };
      }
      const res = await api.policyReview.getPolicyReviewDashboard(payload);

      if (
        res.data.entityData &&
        res.data.entityData.companies &&
        res.data.entityData.companies.length > 0
      ) {
        if (
          res.data.entityData.companies[0].sites.length > 0 &&
          res.data.entityData.companies[0].sites[0].groups.length > 0
        ) {
          this.data = res.data.entityData.companies[0].sites[0].groups[0];
        }
      }
    },
    applyDecision() {
      let mainId = 0;
      try {
        const agmsGroupString = localStorage.getItem("agms_group");
        const agmsGroup = JSON.parse(agmsGroupString);
        mainId = agmsGroup.mainid;
      } catch (error) {
        console.log(error);
      }
      const url = `/administration/policy-tuning?mainId=${mainId}&decisionStatusId=1`;
      this.$router.push(url);
    },
    goTo(link) {
      this.$router.push({ path: link });
    },
    searchResultFunc() {
      this.$emit("searchResultFunc");
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-stepper-horizontal {
  display: table;
  width: 100%;
  max-width: calc(100% - 270px);
  padding: 48px 24px;
  padding-top: 90px;
  padding-bottom: 0px;
}

.has-no-action {
  padding-bottom: 55px;
  margin-top: 10px;
  .ag-step-bar-left,
  .ag-step-bar-right {
    top: 16px !important;
  }
}

.has-action {
  position: relative;
  top: -50px;
  .ag-step-bar-left,
  .ag-step-bar-right {
    top: 76px !important;
  }

  .ag-step-circle {
    margin-top: -7px !important;
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
  }
}

.has-active-no-btn {
  .ag-step-circle {
    margin-top: -7px !important;
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
  }

  small {
    margin-top: -40px !important;
  }
}

.ag-action-btn {
  max-width: 140px;
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 15px;
}

.ag-stepper-horizontal .ag-step {
  display: table-cell;
  position: relative;
  cursor: pointer;
  width: 100px;
}

.ag-step.active small {
  margin-top: -20px;
  text-align: center;
  display: block;
  position: absolute;
  font-size: 11px;
  color: #6a6767;
  font-weight: 400;
  width: 100%;
}

.ag-stepper-horizontal .ag-step:first-child:active {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ag-stepper-horizontal .ag-step:last-child:active {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.ag-stepper-horizontal .ag-step:hover .ag-step-circle {
  background-color: #757575;
}
.ag-stepper-horizontal .ag-step:first-child .ag-step-bar-left,
.ag-stepper-horizontal .ag-step:last-child .ag-step-bar-right {
  display: none;
}
.ag-stepper-horizontal .ag-step .ag-step-circle {
  width: 30px;
  height: 30px;
  margin: 0 auto;
  background-color: #999999;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
}
.ag-stepper-horizontal.green .ag-step.active .ag-step-circle {
  background-color: #00ae4d;
}
.ag-stepper-horizontal .ag-step.active .ag-step-circle {
  background-color: #ed9c93 !important;
}
.ag-stepper-horizontal .ag-step.active .ag-step-circle {
  background-color: rgb(33, 150, 243);
}
.ag-stepper-horizontal .ag-step.done .ag-step-circle:before {
  font-family: "FontAwesome";
  font-weight: 100;
  content: "\f00c";
}
.ag-stepper-horizontal .ag-step.done .ag-step-circle *,
.ag-stepper-horizontal .ag-step.editable .ag-step-circle * {
  display: none;
}
.ag-stepper-horizontal .ag-step.editable .ag-step-circle {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
.ag-stepper-horizontal .ag-step.editable .ag-step-circle:before {
  font-family: "FontAwesome";
  font-weight: 100;
  content: "\f040";
}
.ag-stepper-horizontal .ag-step .ag-step-title {
  margin-top: 16px;
  font-weight: 400;
  color: #4c8dbb;
  font-size: 18px;
  text-align: center;
}
.ag-stepper-horizontal .ag-step .ag-step-title:hover {
  text-decoration: none;
}
.ag-stepper-horizontal .ag-step .ag-step-title.active-title {
  font-weight: 600;
  color: #1878af;
  border-bottom: 2px solid #1878af;
  padding-bottom: 10px;
}

.ag-stepper-horizontal .ag-step.active.done .ag-step-title,
.ag-stepper-horizontal .ag-step.active.editable .ag-step-title {
  font-weight: 600;
}
.ag-stepper-horizontal .ag-step .ag-step-optional {
  font-size: 12px;
}
.ag-stepper-horizontal .ag-step.active .ag-step-optional {
  color: rgba(0, 0, 0, 0.54);
}
.ag-stepper-horizontal .ag-step .ag-step-bar-left,
.ag-stepper-horizontal .ag-step .ag-step-bar-right {
  position: absolute;
  top: 26px;
  height: 1px;
  border-top: 1px solid #dddddd;
}
.ag-stepper-horizontal .ag-step .ag-step-bar-right {
  right: 0;
  left: 50%;
  margin-left: 20px;
}
.ag-stepper-horizontal .ag-step .ag-step-bar-left {
  left: 0;
  right: 50%;
  margin-right: 20px;
}
</style>
